export default "__VITE_ASSET__BKM7oh1r__"